module.exports = __webpack_public_path__ + "static/img/img-home-jzg-05.8e62776.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-jzg-05.png
// module id = Wu9O
// module chunks = 1